import { eHierarchyLevel } from "./api/enums";

/**
 * Returns the level for the parent of the current hierarchy
 *
 * @param hierarchyLevel - The current hierarchy level
 * @returns eHierarchyLevel
 */
export const parentHierarchyLevel = (hierarchyLevel: eHierarchyLevel): eHierarchyLevel => {
  switch (hierarchyLevel) {
    case eHierarchyLevel.TopLevel:
    case eHierarchyLevel.Corporate:
      return eHierarchyLevel.TopLevel;
    case eHierarchyLevel.TA:
      return eHierarchyLevel.Corporate;
    case eHierarchyLevel.Project:
      return eHierarchyLevel.TA;
    case eHierarchyLevel.Study:
      return eHierarchyLevel.Project;
    case eHierarchyLevel.Report:
      return eHierarchyLevel.Study;
  }
};
